import { Component, OnInit } from '@angular/core';
import { Po } from '../po';
import { PoService } from '../po.service';
import { AuthService } from '../../auth.service';
import { ActivatedRoute, Params } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { Location } from '@angular/common';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { SlideInOutAnimation } from '../../animations';
import { PotrackingListPipe } from '../../pipe/potracking.pipe';

@Component({
  selector: 'app-potracking',
  templateUrl: './potracking.component.html',
  styleUrls: ['./potracking.component.css'],
  animations: [SlideInOutAnimation]
})
export class PotrackingComponent implements OnInit {

  closeResult: string; 
  page=1;
  SearchText:string ='';
  currentPage = 1;
  itemsPerPage = 5;
  pageSize: number;
  potracking = new Po();  //Po is defined from abobe import po
  potrackings: Po[];
  submitted = false;
  message: string;	
  public expandedIndex:number
  private active : number;
  animationState = "out"
  poTrackingFilter: any = { ponumber: '' };
  totalrecord:number; 

 


  constructor(
    private poService: PoService,
    private route: ActivatedRoute,
    private spinnerService: Ng4LoadingSpinnerService,
    private location: Location,
    private modalService: NgbModal,
	 private auth: AuthService
  ) { }

  ngOnInit() {
    this.getPoTrackings();
    this.expandedIndex=-1;
  }

  // expandRow(index: number): void {
  //   this.expandedIndex = index === this.expandedIndex ? -1 : index;
  // }

  closeAllTips(): void {
    this.potrackings.forEach((tip) => {
      tip.active = 0;
    });
  }

  showContent(tip) {
    if (!tip.active) {
      this.closeAllTips();
    }
    tip.active = !tip.active;
  }

  getPoTrackings() {
    this.spinnerService.show();    
	 if(this.auth.currentUserValue.userroleid == 4){
		 
    return this.poService.getUserPoTrackings(this.auth.currentUserValue.userid)
               .subscribe(
                potrackings => {              
                  this.potrackings = potrackings.sort((a, b) => {
					  return <any>new Date(b.podate) - <any>new Date(a.podate);
					});
                  
                  this.spinnerService.hide();
                  this.totalrecord = this.potrackings.length;
                  
                 }
                );
	 }
	 else if(this.auth.currentUserValue.userroleid == 2){
		 
		  return this.poService.getApprovalPoTrackings(this.auth.currentUserValue.userid)
               .subscribe(
                potrackings => {              
                  this.potrackings = potrackings.sort((a, b) => {
					  return <any>new Date(b.podate) - <any>new Date(a.podate);
					});
                  
                  this.spinnerService.hide();
                  this.totalrecord = this.potrackings.length;
                  
                 }
                );
	 }
	 else if(this.auth.currentUserValue.userroleid == 5){
		 
		  return this.poService.getRequestorPoTrackings(this.auth.currentUserValue.userid)
               .subscribe(
                potrackings => {              
                  this.potrackings = potrackings.sort((a, b) => {
					  return <any>new Date(b.podate) - <any>new Date(a.podate);
					});
                  
                  this.spinnerService.hide();
                  this.totalrecord = this.potrackings.length;
                  
                 }
                );
	 }
	 else if(this.auth.currentUserValue.userroleid == 6){
		 return this.poService.getReviewerPoTrackings(this.auth.currentUserValue.userid)
               .subscribe(
                potrackings => {              
                  this.potrackings = potrackings.sort((a, b) => {
					  return <any>new Date(b.podate) - <any>new Date(a.podate);
					});
                  
                  this.spinnerService.hide();
                  this.totalrecord = this.potrackings.length;
                  
                 }
                );
	 }
	 else
	 {
		  return this.poService.getPoTrackings()
               .subscribe(
                potrackings => {              
                  this.potrackings = potrackings.sort((a, b) => {
					  return <any>new Date(b.podate) - <any>new Date(a.podate);
					});
                  
                  this.spinnerService.hide();
                  this.totalrecord = this.potrackings.length;
                  
                 }
                );
	 }
	 
 }


 public onPageChange(pageNum: number): void {
  this.pageSize = this.itemsPerPage*(pageNum - 1);
}

public changePagesize(num: number): void {
this.itemsPerPage = this.pageSize + num;
}



}
